import type { SidebarItem } from './sidebarItems';
import { ENTITIES, getEntityPermissions } from './entityPermissions';
import { ROLES } from './roles';

/**
 * Accesso ai Rimborsi per i tenant in cui il BE li apre solo a un gruppo (campo `refundsEnabled` di UserInfo).
 * Modulo temporaneo: va rimosso insieme alla restrizione BE `RefundsAccess`.
 */

export interface RefundsUserInfo {
	refundsEnabled?: boolean;
	roles?: readonly string[];
}

const REFUNDS_ROUTE = '/refund/refunds';

// Stessa voce di sidebarItems.ts (modulo Refunds), duplicata qui per non toccare quel file.
export const REFUNDS_SIDEBAR_ITEM: SidebarItem = {
	label: 'Rimborsi',
	icon: 'el-icon-document-checked',
	restrictedTo: getEntityPermissions(ENTITIES.REFUNDS).roles,
	children: [
		{
			label: 'Ricerca',
			route: REFUNDS_ROUTE,
			restrictedTo: getEntityPermissions(ENTITIES.REFUNDS).roles,
		},
	],
};

export function canUseRefundsMenu(
	moduleFlag: boolean,
	userInfo: RefundsUserInfo | null | undefined,
): boolean {
	return moduleFlag || userInfo?.refundsEnabled === true;
}

export function withRefundsItem(
	items: readonly SidebarItem[],
	userInfo: RefundsUserInfo | null | undefined,
	moduleFlag: boolean,
): SidebarItem[] {
	const alreadyPresent = items.some((item) =>
		item.children?.some((child) => child.route === REFUNDS_ROUTE),
	);
	if (moduleFlag || userInfo?.refundsEnabled !== true || alreadyPresent) {
		return [...items];
	}
	return [...items, REFUNDS_SIDEBAR_ITEM];
}

export function isRefundsRouteAllowed(
	moduleFlag: boolean,
	userInfo: RefundsUserInfo | null | undefined,
): boolean {
	return (
		canUseRefundsMenu(moduleFlag, userInfo) || (userInfo?.roles ?? []).includes(ROLES.SYS_ADMIN)
	);
}
